<div  class = "main">
  <div *ngIf="isReady" class="middle">

    <div class="spinner"></div>
    <br/>
  </div>
    <div class = "up">
        
        <div class = "upLeft">
          <h1>{{name}}</h1> 
          <hr />
            <div class = "leftUpBox">
              <div>
                <img src="../../assets/images/logos/classified.svg"class="icon"/>
                <div class="letters">
                  <p class="normalLetters">Type: </p>
                  <p class="boldLetters">{{nameInfo.type}}</p>
              </div>
              </div>
              <div>
                <img src="../../assets/images/logos/review.svg" class="icon" />
                <div class="letters">
                    <p class="normalLetters">Rating: </p>
                    
                    <p class="boldLetters" style="font-size: 4vh;">{{nameInfo.rating || "NA"}}</p>
                </div>
              </div>
              
              <div>
                <img src="../../assets/images/logos/route.svg" class="icon"/>
                <div class="letters">
                  <p class="normalLetters">Episodes: </p>
                  <p class="boldLetters">{{nameInfo.episodes || "NA"}}</p>
                </div>
              </div>
              
             
            </div>
            <div class="leftDownBox">
                <div *ngFor="let genre of nameInfo.genre; let i = index">
                  <a [routerLink]="['/typepagecomponent',genre]">
                    <div class="circle">
                      {{genre}}
                    </div>
                  </a>
                </div>
            </div>
        </div>
        <div class = "upRight">
          <h2 style="display:inline">Ranking </h2>
          <img src="../../assets/images/logos/ranking.svg" style="display:inline" width="30vh" />
          <hr style="margin-bottom: 3vh;"/>
            <div class="rankingBox">
              <div *ngFor="let ranking of rankings; let i = index">
                <div (click) ="navigate(ranking.name)"
                > 
                  <p >{{i+1 }}.{{"  "}}  {{ranking.name}} ({{ranking.rating || "NA"}})</p>
                </div>
              </div>
          </div>
        </div>
       
    </div>
    <div class = "bottom">
      <h3 style="display:inline">Recommendation {{"  "}}</h3>
      
      <img src="../../assets/images/logos/list.svg" style="display:inline" width ="30vh"/>
      <hr/>
      <div class = "bottomBox">
        <div *ngFor="let anime of recommendations; let i = index" >
          <div (click)="navigate(anime[0].name)" > 
            <div class = "card" > 
              <p class="recommendationHeader"  style="display:inline">{{i+1 }}.{{"  "}} {{anime[0].name}} - {{anime[0].rating || "NA"}}  </p>
              <!--
              <div *ngFor="let genre of anime[0].genre">
                <p class="recommendedGenre">{{genre}}</p>
              </div>-->
            </div>
          </div>
        </div>
    </div>
    </div>
</div>
